<template>
  <div class="col-md-6 col-sm-12 hidden-xs align-right footer-bottom">
    <p>
      <a href="mailto:jakub@foobar.beer">jakub@foobar.beer</a><br>
      <a href="https://www.linkedin.com/in/stonavsky/"><icon name="linkedin"></icon></a>
      <a href="https://twitter.com/0xCBEE"><icon name="twitter"></icon></a>
    </p>
  </div>
</template>

<script>
  import 'vue-awesome/icons'
  import Icon from 'vue-awesome/components/Icon.vue'

  export default {
    components: { Icon }
  }
</script>



// WEBPACK FOOTER //
// FooterContact.vue?ca58fddc